import { Account, ManagementType } from '@ndvr/portfolio-api';

/**
 * CashEQ sweep value to show in an editor after the management type is changed.
 *
 * Switching a persisted non-automatic account to AUTOMATIC turns the sweep on; the user can still
 * switch it off explicitly before saving. Any other change restores the account's saved value.
 */
export const defaultCashEqSweep = (
    savedAccount: Pick<Account, 'managementType' | 'cashEqSweep'>,
    newManagementType: ManagementType,
): boolean => {
    const entersAutomatic =
        newManagementType === ManagementType.AUTOMATIC && savedAccount.managementType !== ManagementType.AUTOMATIC;
    return entersAutomatic || savedAccount.cashEqSweep;
};
